import React from "react";

const BackdropLoading = () => {
	let spinnerColor = "#34637C";
	try {
		spinnerColor = localStorage.getItem("primaryColorLight") || localStorage.getItem("primaryColorDark") || "#34637C";
	} catch (e) {}

	return (
		<div style={{
			position: "fixed",
			inset: 0,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			backgroundColor: "rgba(255, 255, 255, 0.6)",
			zIndex: 9999,
		}}>
			<div style={{
				width: 36,
				height: 36,
				border: "2px solid rgba(0, 0, 0, 0.08)",
				borderTopColor: spinnerColor,
				borderRadius: "50%",
				animation: "app-spin 0.6s cubic-bezier(0.4, 0, 0.2, 1) infinite",
			}} />
		</div>
	);
};

export default BackdropLoading;
